import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ROUTES } from './routes';

import Landing from 'modules/Landing';
// import ForgottenPassword from 'modules/ForgottenPassword';
// import ResetPassword from 'modules/ForgottenPassword/Reset';
// import VerifyCode from 'modules/ForgottenPassword/Verify';
import ResourceAdd from 'modules/Resource/componenets/ResourceAdd';
import ResourcePage from 'modules/Resource';

import HomePage from 'modules/Home';

import ProfilePage from 'modules/Profile';

// import ExperiencerBookings from 'modules/Bookings';
import BookingDetailsPage from 'modules/Bookings/components/Calendar/BookingDetailsPage';
import BookingPage from 'modules/Bookings/Booking';
import GlobalBookings from 'modules/Bookings';
import GlobalAddBooking from 'modules/Bookings/components/GlobalAddBooking';

// Experience
import ExperienceListPage from 'modules/Experience/ExperienceList';
import ExperienceWizardPage from 'modules/Experience/ExperienceWizard';
import ExperienceProfilePage from 'modules/Experience/ExperienceProfile';
import ExperienceResourcePage from 'modules/Experience/ExperienceResource';
import ExperienceTermsPage from 'modules/Experience/ExperienceTerms';
import ExperienceCalendarPage from 'modules/Experience/ExperienceCalendar';
import ExperienceOptionsPage from 'modules/Experience/ExperienceOptions';
import ExperienceUnitsPage from 'modules/Experience/ExperienceUnits';
import ExperienceEditPage from 'modules/Experience/ExperienceEdit';
import ExperienceIdPage from 'modules/Experience/ExperienceId';

import RedirectRoute from './redirectRoute';
import BookingNewPage from 'modules/Bookings/components/BookingNewLegacy';
import PaymentValidation from 'modules/Bookings/components/BookingNewLegacy/components/PaymentValidation';
import UnitsPage from 'modules/Units';

// Pricing
import PriceListPage from 'modules/Pricing/PriceList';
import PriceListIdPage from 'modules/Pricing/PriceListId';
import PriceGroupWizard from 'modules/Pricing/PriceGroupWizard';
import PriceGroupIdPage from 'modules/Pricing/PriceGroupId';
import UploadStatus from 'components/UploadStatus';

import ReportsPage from 'modules/Reports';

const Router = () => (
    <BrowserRouter>
        <UploadStatus />

        <Switch>
            <Route path={ROUTES.LANDING} exact>
                <Landing />
            </Route>
            {/* <Route path={ROUTES.FORGOTTEN_PASSWORD.VERIFY} component={VerifyCode} exact />
            <Route path={ROUTES.FORGOTTEN_PASSWORD.RESET} component={ResetPassword} exact />
            <Route path={ROUTES.FORGOTTEN_PASSWORD.SEND} component={ForgottenPassword} /> */}
            <RedirectRoute path={ROUTES.HOME} component={HomePage} />
            <RedirectRoute path={ROUTES.PROFILE} component={ProfilePage} />

            {/* Experience */}
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCELIST} component={ExperienceListPage} exact />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEWIZARD} component={ExperienceWizardPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEPROFILE} component={ExperienceProfilePage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCERESOURCE} component={ExperienceResourcePage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCETERMS} component={ExperienceTermsPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCESCHEDULING} component={ExperienceCalendarPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEOPTIONS} component={ExperienceOptionsPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEUNITS} component={ExperienceUnitsPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEEDIT} component={ExperienceEditPage} />
            <RedirectRoute path={ROUTES.EXPERIENCE.EXPERIENCEID} component={ExperienceIdPage} />

            <RedirectRoute path={ROUTES.CHECKOUT_VALIDATION} component={PaymentValidation} exact />

            <RedirectRoute path={ROUTES.BOOKINGS.ADD} component={GlobalAddBooking} exact />
            <RedirectRoute path={ROUTES.BOOKINGS.NEW} component={BookingNewPage} exact />
            <RedirectRoute path={ROUTES.BOOKINGS.ID} component={BookingPage} exact />
            <RedirectRoute path={ROUTES.BOOKINGS.DATE} component={BookingDetailsPage} exact />
            <RedirectRoute path={ROUTES.BOOKINGS.GLOBAL} component={GlobalBookings} />
            <RedirectRoute path={ROUTES.RESOURCE.RESOURCE} exact>
                <ResourcePage />
            </RedirectRoute>
            <RedirectRoute path={ROUTES.RESOURCE.ADD} exact>
                <ResourceAdd />
            </RedirectRoute>
            <RedirectRoute path={ROUTES.UNITS} component={UnitsPage} exact />

            {/* Pricing */}
            <RedirectRoute path={ROUTES.PRICING.PRICELIST} component={PriceListPage} exact />
            <RedirectRoute path={ROUTES.PRICING.PRICEGROUPWIZARD} component={PriceGroupWizard} />
            <RedirectRoute path={ROUTES.PRICING.PRICELISTID} component={PriceListIdPage} />
            <RedirectRoute path={ROUTES.PRICING.PRICEGROUPID} component={PriceGroupIdPage} />

            <RedirectRoute path={ROUTES.REPORTS} component={ReportsPage} exact />
        </Switch>
    </BrowserRouter>
);

Router.displayName = 'Router';

export default Router;
